import { inject, injectable } from 'inversify';
import Debug from 'debug';
import { CommandHandler, createCommand } from '@/app/tracking/api';
import { DeleteQuizSessionTrackingCommand, DeleteQuizSessionTrackingCommandPayload } from '../api'
import { QuizSessionSuspendDataStore } from '../common';

const debug = Debug('scorm2004-delete-quiz-session-command-handler')

@injectable()
export class Scorm2004DeleteQuizSessionCommandHandler implements CommandHandler<DeleteQuizSessionTrackingCommand> {

  constructor (
    @inject(QuizSessionSuspendDataStore)
    private store: QuizSessionSuspendDataStore,
  ) {}
  
  public async execute(command: DeleteQuizSessionTrackingCommandPayload) {

    debug('execute', command)

    await this.store.execute(createCommand<DeleteQuizSessionTrackingCommand>('delete-quiz-session', command))
  }
}
